<template>
  <v-card>
    <v-form @submit.prevent="submitAddSpoil()" ref="addSpoilForm">
      <v-card-title>
        <span class="headline">Add Spoil {{isRequest || spoil.request ? 'Request' : ''}}</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field label="* Name" v-model="spoil.name" :rules="nameRules"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              :items="spoilTypes"
              color="indigo"
              v-model="spoil.type"
              :rules="typeRules"
              label="Type"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="!isRequest">
            <v-switch label="Request" v-model="spoil.request"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn
          :color="primaryNeutral"
          flat
          type="submit"
          :loading="addingSpoil"
        >{{ isRequest || spoil.request ? 'Create Request' : 'Add'}}</v-btn>
      </v-card-actions>
    </v-form>

    <select-tips v-model="spoil.selectedTips" :items="tips" title="Allowed Tips" route="tip"></select-tips>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SpoilService from '@/services/requests/spoilService'
import SpoilValidation from '@/services/validation/spoilValidation'

import getTips from '@/services/mixins/getMasterFiles/getTips'
import SelectTips from '@/components/ui/selectTipSpoils'
export default {
  components: {
    SelectTips,
  },
  mixins: [getTips, SpoilValidation],
  props: {
    isRequest: Boolean,
  },
  data() {
    return {
      spoil: {
        name: '',
        type: 'SPL',
        selectedTips: [],
        request: false,
      },
      addingSpoil: false,
      spoilTypes: [
        {
          text: 'Spoil',
          value: 'SPL',
        },
        {
          text: 'Toll',
          value: 'TOL',
        },
        {
          text: 'Internal Use',
          value: 'INT',
        },
      ],
    }
  },
  methods: {
    submitAddSpoil() {
      if (!this.$refs.addSpoilForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      if (!this.spoil.selectedTips.length) {
        this.snack({ text: 'Please select 1 or more tip', color: 'red' })
        return
      }
      this.addSpoil()
    },
    addSpoil() {
      this.loading = true
      if (this.isRequest) this.spoil.request = this.isRequest
      SpoilService.addSpoil(this.spoil)
        .then((result) => {
          this.loading = false
          this.$store.commit('spoils/addToArrayState', {
            prop: 'spoils',
            value: result.data.result,
          })
          this.resetForm()
          this.snack({ text: 'Spoil was added!', color: 'green' })
          this.close()
        })
        .catch((err) => {
          this.snackError()
          this.addingSpoil = false
          console.log(err)
        })
    },
    resetForm() {
      this.spoil.name = ''
      this.spoil.type = 'SPL'
      this.spoil.selectedTips = []
      this.$refs.addSpoilForm.resetValidation()
    },
    close() {
      this.$emit('close')
    },
  },
  mounted() {},
}
</script>

<style>
</style>
